export default {"src":"/_next/static/media/planet_1.fac28142.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};